import React from "react";
import { Box, Button, CssBaseline, Grid } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import Warning from "../Assets/warning.png";
import classes from "../Style/Layout.scss";

import Sidebar from "./Sidebar";
import PageRoutes from "../Config/PageRoutes";
import DesktopHeader from "./DesktopHeader";
import MobileHeader from "./MobileHeader";
import ImportantConceptsLink from "./ImportantConceptsLink";
import ImportantConceptsLinkMobile from "./ImportantConceptsLinkMobile";
import { useEffect, useState } from "react";

const Layout = () => {
  const location = useLocation();
  // console.log(location);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  const [warning, setWarning] = useState(isMobile);
  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 900);
    }

    window.addEventListener("resize", handleResize);
    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return (
    <React.Fragment>
      <CssBaseline />
      {warning ? (
        <Grid
          style={{
            height: "100vh",
            width: "100%",
            position: "fixed",
            top: 0,
          }}
        >
          <img
            //   loading="lazy"
            //   class="img-fluid"
            alt="warning icon"
            src={Warning}
            style={{ width: "auto", height: "100%" }}
          ></img>

          <Grid
            style={{
              // height: "100vh",
              // width: "100%",
              position: "fixed",
              left: "115px",
              bottom: "20px",
            }}
          >
            <Button
              style={{
                backgroundColor: "#22294d",
                color: "white",
                fontSize: "14px",
                fontFamily: "Roboto-Bold, Roboto",
              }}
              onClick={() => setWarning(false)}
            >
              Accept and continue
            </Button>
          </Grid>
        </Grid>
      ) : (
        <Box sx={{ flexGrow: 1 }}>
          <Grid
            container
            flexWrap="noWrap"
            direction={{ xs: "column", sm: "column", md: "row" }}
          >
            <Grid
              id="sidebar"
              item
              xs="auto"
              sx={{ display: { xs: "none", sm: "none", md: "block" } }}
            >
              <Sidebar path={location.pathname} />
            </Grid>
            <Grid
              id="mobileHeader"
              item
              xs="auto"
              sx={{
                display: { xs: "block", sm: "block", md: "none" },
                zIndex: 9999,
                position: "sticky",
                top: 0,
              }}
            >
              <MobileHeader path={location.pathname} />
            </Grid>

            <Grid item xs>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                {!(location.pathname.indexOf(PageRoutes.CHAPTER_TWO) > -1) &&
                  !(
                    location.pathname.indexOf(PageRoutes.IMPORTANT_CONCEPTS) >
                    -1
                  ) && (
                    <Box
                      sx={{
                        display: { xs: "none", sm: "none", md: "block" },
                        zIndex: 9999,
                        position: "sticky",
                        top: 0,
                      }}
                    >
                      <DesktopHeader path={location.pathname} />
                    </Box>
                  )}
                {!(
                  location.pathname.indexOf(PageRoutes.IMPORTANT_CONCEPTS) > -1
                ) && (
                  <Box
                    sx={{
                      display: { xs: "none", sm: "none", md: "block" },
                      zIndex: 800,
                      position: "sticky",
                      top: 0,
                    }}
                  >
                    <ImportantConceptsLink />
                  </Box>
                )}

                {!(
                  location.pathname.indexOf(PageRoutes.IMPORTANT_CONCEPTS) > -1
                ) && (
                  <Box
                    sx={{
                      display: { xs: "block", sm: "block", md: "none" },
                      zIndex: 800,
                      position: "sticky",
                      top: 0,
                    }}
                  >
                    <ImportantConceptsLinkMobile />
                  </Box>
                )}

                <Outlet />
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}
    </React.Fragment>
  );
};

export default Layout;
